import '../../css/base.css';

const Outdoors = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Outdoors</h2>
      <p className="your-stay-text">Garden table, chairs and BBQ located in garden and/or utility. Please feel
                                    free move these to the front of the cottage if you want to sit with a view.
                                    Please return to the garden/utility on departure. 
      </p>                                            
      <p className="your-stay-text">There is also a bench at the front of the cottage where you can watch the world go by.
      </p>                                            
    </div>
  );
}

export default Outdoors;